import gsap from 'gsap'
import barba from '@barba/core';
import { historyBack } from '../utils/helper';

document.addEventListener("DOMContentLoaded", () => {
    const leadershipDetailElement = document.querySelector("#leadership-detail-modal")

    if (!leadershipDetailElement) {
        return
    }

    initLeadershipDetails(leadershipDetailElement)
})

/**
 * @param {HTMLDivElement} leadershipDetailElement 
 */
function initLeadershipDetails(leadershipDetailElement) {
    const closeButton = leadershipDetailElement.querySelector("#leadership-close-button");

    const leadershipModel = new bootstrap.Modal(leadershipDetailElement, {
        // backdrop: 'static',
        keyboard: false,
    })

    function checkShowModel(show = true) {
        const modal = leadershipDetailElement.querySelector(".leadership-show-model")
        if (modal) {
            if (show) {
                leadershipModel.show()
            }
            else {
                leadershipModel.hide()
            }
        }
    }

    function handleClose() {
        if (document.querySelector("[widget-type=TabProperties]")) {
            historyBack()
        }
        else {
            location = "../"
        }
    }

    checkShowModel()

    closeButton.addEventListener("click", () => {
        leadershipModel.hide()
    })

    // leadershipDetailElement.addEventListener('shown.bs.modal', function () { });

    // Remove the event listener when the modal is hidden
    leadershipDetailElement.addEventListener('hidden.bs.modal', function (e) {
        handleClose()
    });

    const DURATION = 0.5
    barba.init({
        prevent: (data) => {
            if (data.el.getAttribute("data-barba-allow")) {
                // console.log("[barba-allow]", data)
                return false
            }
            // console.log("[barba-prevent]", data)
            return true
        },
        // debug: true,
        transitions: [{
            // sync: true,
            name: 'modal-open-transition',
            from: {
                namespace: [
                    "leadership-list",
                    "leadership-details"
                ],
            },
            to: {
                namespace: [
                    "leadership-details",
                    "leadership-list",
                ]
            },
            afterLeave(data) {
                return data.current.container.remove()
            },
            leave(data) {
                checkShowModel(false)
                console.log("[barba-leave]", data)
                const target = data.current.container.querySelectorAll(".leadership-details-animate")
                console.log({ target })
                if (target.length > 0) {
                    return gsap.to(target, {
                        duration: DURATION,
                        opacity: 0,
                        display: "none"
                    });
                }
                return null
            },
            enter(data) {
                checkShowModel()
                console.log("[barba-enter]", data)
                const target = data.next.container.querySelectorAll(".leadership-details-animate")
                console.log({ target })
                if (target.length > 0) {
                    return gsap.from(target, {
                        duration: DURATION,
                        opacity: 0
                    });
                }
                return null
            }
        }]
    });
}
